import { render, staticRenderFns } from "./CreditPurposes.vue?vue&type=template&id=2aa5f9e0&"
import script from "./CreditPurposes.vue?vue&type=script&lang=js&"
export * from "./CreditPurposes.vue?vue&type=script&lang=js&"
import style0 from "./CreditPurposes.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports